import React, { useState, useEffect, useRef, useLayoutEffect } from 'react';
import './NavbarMobile.css';
import { Link as Anchor, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faUser, faHeart, faBell, faBoxOpen, faShoppingCart } from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import baseURL from '../url';

export default function NavbarMobile() {
    const location = useLocation();
    const [storeStatus, setStoreStatus] = useState(null);
    const initialActive = (() => { const p = location.pathname || ''; if (p === '/') return 'home'; if (p.startsWith('/productos')) return 'prod'; return 'home'; })();
    const [activeKey, setActiveKey] = useState(initialActive);
    const [pulse, setPulse] = useState(0);
    const [cartCount, setCartCount] = useState(0);
    const favRef = useRef(null);
    const wppRef = useRef(null);
    const homeRef = useRef(null);
    const cartRef = useRef(null);
    const prodRef = useRef(null);
    const [notchLeft, setNotchLeft] = useState('50%');
    const containerRef = useRef(null);

    useEffect(() => {
        fetch(`${baseURL}/estado.php`).then(r=>r.json()).then(d=>{ if(!d.error){ setStoreStatus(d.estado); } }).catch(()=>{});
    }, []);

    useEffect(() => {
        const updateCart = () => {
            try{ const c = JSON.parse(localStorage.getItem('cart'))||[]; const count = Array.isArray(c) ? c.length : 0; setCartCount(count); }catch(_){ setCartCount(0); }
        };
        updateCart();
        window.addEventListener('storage', updateCart);
        window.addEventListener('cart-updated', updateCart);
        return () => { window.removeEventListener('storage', updateCart); window.removeEventListener('cart-updated', updateCart); };
    }, []);

    const notchMap = {
        fav: '10%',
        wpp: '30%',
        home: '50%',
        cart: '70%',
        prod: '90%'
    };

    const setActive = (key, action) => { setActiveKey(key); setPulse(p=>p+1); if (action) action(); };

    const computeNotch = () => {
        const map = { fav: favRef.current, wpp: wppRef.current, home: homeRef.current, cart: cartRef.current, prod: prodRef.current };
        const el = map[activeKey];
        const container = el ? el.closest('.nav-pill') : null;
        const target = el ? (el.querySelector('svg') || el) : null;
        if (container && target) {
            const tRect = target.getBoundingClientRect();
            const cRect = container.getBoundingClientRect();
            const centerPx = (tRect.left - cRect.left) + (tRect.width / 2);
            setNotchLeft(`${Math.round(centerPx)}px`);
        }
    };

    useEffect(() => {
        const p = location.pathname || '';
        if (p === '/') { setActiveKey('home'); setPulse(pu=>pu+1); }
        else if (p.startsWith('/productos')) { setActiveKey('prod'); setPulse(pu=>pu+1); }
    }, [location.pathname]);

    useLayoutEffect(() => { computeNotch(); }, [activeKey]);
    useEffect(() => { const id = setTimeout(() => { computeNotch(); requestAnimationFrame(computeNotch); setTimeout(computeNotch, 120); setTimeout(computeNotch, 240); }, 0); return () => clearTimeout(id); }, [location.pathname]);
    useEffect(() => { const id = setTimeout(() => { computeNotch(); requestAnimationFrame(computeNotch); setTimeout(computeNotch, 120); setTimeout(computeNotch, 240); }, 0); return () => clearTimeout(id); }, []);
    useEffect(() => {
        const el = containerRef.current;
        if (el && typeof ResizeObserver!=='undefined') {
            const ro = new ResizeObserver(() => computeNotch());
            ro.observe(el);
            return () => ro.disconnect();
        }
    }, []);
    useEffect(() => { try { if (document && document.fonts && document.fonts.ready) { document.fonts.ready.then(() => computeNotch()); } } catch(_){} }, []);
    useEffect(() => {
        const onResize = () => computeNotch();
        window.addEventListener('resize', onResize);
        return () => window.removeEventListener('resize', onResize);
    }, []);

    return (
        <section ref={containerRef} className={`scrolledMobile nav-pill`} aria-label='Menú inferior móvil'>
            <button ref={favRef} type='button' className={`nav-item ${activeKey==='fav' ? 'active' : ''}`} aria-label='Favoritos' onClick={()=> setActive('fav', ()=>{ window.dispatchEvent(new Event('close-all-overlays')); window.dispatchEvent(new Event('open-favoritos')); })}>
                <FontAwesomeIcon icon={faHeart} />
                <strong>Favoritos</strong>
            </button>
            <button ref={wppRef} type='button' className={`nav-item ${activeKey==='wpp' ? 'active' : ''}`} aria-label='WhatsApp' onClick={()=> setActive('wpp', ()=>{ window.dispatchEvent(new Event('close-all-overlays')); window.dispatchEvent(new Event('open-whatsapp')); })}>
                <FontAwesomeIcon icon={faWhatsapp} />
                <strong>WhatsApp</strong>
            </button>
            <Anchor ref={homeRef} to={`/`} className={`nav-item home-item ${activeKey==='home' ? 'active' : ''}`} aria-label='Home' onClick={()=> setActive('home', ()=>{ window.dispatchEvent(new Event('close-all-overlays')); })}>
                <FontAwesomeIcon icon={faHome} />
                <strong>Home</strong>
            </Anchor>
            <button ref={cartRef} type='button' className={`nav-item ${activeKey==='cart' ? 'active-pink' : ''}`} aria-label='Carrito' onClick={()=> setActive('cart', ()=>{ window.dispatchEvent(new Event('close-all-overlays')); window.dispatchEvent(new Event('open-cart')); })}>
                <FontAwesomeIcon icon={faShoppingCart} />
                {cartCount>0 && ((()=>{ const display = cartCount>9 ? '9+' : String(cartCount); return (<div className='cart-counter'>{display}</div>); })())}
                <strong>Carrito</strong>
            </button>
            <Anchor ref={prodRef} to='/productos' className={`nav-item prod-item ${activeKey==='prod' ? 'active' : ''}`} aria-label='Productos' onClick={()=> setActive('prod', ()=>{ window.dispatchEvent(new Event('close-all-overlays')); })}>
                <FontAwesomeIcon icon={faBoxOpen} />
                <strong>Productos</strong>
            </Anchor>
        </section>
    );
}
